export default (ref) => ref?.current?.focus();
